import { GET_CAMPAIGNS, GET_CAMPAIGNS_SUCCESS, GET_CAMPAIGNS_ERROR, GET_CAMPAIGNS_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetCampaigns = (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGNS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CAMPAIGNS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_CAMPAIGNS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CAMPAIGNS_EMPTY:
      state = { ...initialState };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetCampaigns;
